import { get } from 'lodash';

export const isLoadingSelector = state => get(state, ['ui', 'isLoading']);



// WEBPACK FOOTER //
// ./src/store/app/selectors.js